import { Alert, Button, Skeleton } from "@mui/material";
import { useLazyGetLatestMovementForTemplateQuery } from "modules/pvs_activities/redux/service/movements";
import React, { useCallback, useContext, useEffect, useMemo } from "react";
import { FaExternalLinkAlt } from "react-icons/fa";
import { FormDataContext } from "../contexts/FormContext";
import { displayNotification, getAPIURL, getBaseURL } from "helpers";
import PopupForm from "modules/pvs_activities/pages/forms/PopupForm";
import { useDownloadDFormMutation } from "modules/pvs_activities/redux/service/downloadForm";
import { useSelector } from "react-redux";

const defaultProps = {
    id: "",
    element: {},
    isReadOnly: false,
};

const DFormButton = (rawProps) => {
    const props = { ...defaultProps, ...rawProps };
    const formDataContext = useContext(FormDataContext);
    const authToken = useSelector((s) => s.auth.accessToken);

    const [downloadDForm] = useDownloadDFormMutation();
    const [latestMovementTrigger, latestMovementRes] = useLazyGetLatestMovementForTemplateQuery();

    useEffect(() => {
        if (props.element.properties.template_id && formDataContext.mode === 'data_entry') {
            latestMovementTrigger({
                missionId: formDataContext.missionId,
                templateId: props.element.properties.template_id,
            });
        }
    }, [props.element.properties.template_id]);
    const formTypeName = useMemo(() => {
        if (latestMovementRes.isSuccess && latestMovementRes.data.status === 200) {
            switch (latestMovementRes.data.data) {
                case 'FT_FRM':
                    return 'Form';
                case 'FT_RPT':
                    return 'Report';
                case 'FT_LTR':
                    return 'Letter';
                default:
                    return 'Form';
            }
        }
        return 'Form';
    }, [latestMovementRes]);

    const renderButton = useCallback((onClickFn, externalLink = true) => {
        return (
            <Button variant={"contained"} color={"primary"} onClick={onClickFn} size={"small"}>
                <span className={externalLink ? "me-1" : ''}>
                    {props.element.properties.dform_button_label}
                </span>
                {externalLink === true && <FaExternalLinkAlt />}
            </Button>
        );
    }, [props.element]);

    const viewForm = () => {
        window.open(
            getBaseURL(`/portal/pvs-activities/dform/${props.element.properties.template_id}/${latestMovementRes.data.data.id}`),
            "_blank"
        );
    }

    const handleClick = useCallback(() => {
        if (latestMovementRes.isSuccess) {
            if (props.element.properties.dform_prefer_pdf_first) {
                openPDF();
            }
            else {
                viewForm()
            }
        }
    }, [latestMovementRes, props.element.properties.template_id]);

    const openPDF = () => {
        if (latestMovementRes?.data?.data?.is_pdf_generated) {
            window.open(
                getAPIURL(
                    `/api/pvsa/mission-documents/download/${latestMovementRes?.data?.data?.document_id}?_token=${authToken}&view=true`
                )
            )
        } else {
            displayNotification(
                "warning",
                `${"First generate pdf then you can view."}`
            )
        }
    };

    return (
        <>
            {props.element.properties.template_id ? (
                latestMovementRes.isSuccess || latestMovementRes.isUninitialized ? (
                    latestMovementRes.isSuccess && latestMovementRes.data.status === 200 ? (
                        latestMovementRes.data.data.dform_is_popup_form ? (
                            <PopupForm
                                mode={"data_entry"}
                                id={props.element.properties.template_id}
                                movementId={latestMovementRes.data.data.id}
                            >
                                {(openModal) => renderButton(openModal, false)}
                            </PopupForm>
                        ) : (
                            renderButton(handleClick)
                        )
                    ) : (
                        renderButton(() => { })
                    )
                ) : (
                    <Skeleton variant="rounded" width={"100%"} height={80} />
                )
            ) : (
                <Alert severity="warning">Please configure DForm Button element correctly.</Alert>
            )}
        </>
    );
};

export default DFormButton;
